import React from 'react';
import { DynamicCatalogBuilder } from '../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
var FailuresReportCatalog = function () {
    var columns = [{
            field: 'Srno.',
            headerName: 'Sr. no.',
            headerAlign: 'center',
            minWidth: 100
        }, {
            type: 'string',
            field: 'State',
            headerName: 'State',
            minWidth: 300,
            flex: 1
        }, {
            field: 'Intensity',
            headerName: 'Intensity',
            minWidth: 300,
            flex: 1
        }, {
            field: 'FRs',
            headerName: 'No of FRs',
            flex: 1
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: columns,
        rows: [{
                id: 1
            }, {
                id: 2
            }],
        dataGridProps: {
            hideFooter: true,
            sx: {
                borderRadius: 0,
                borderLeft: 'none',
                borderRight: 'none',
                borderBottom: 'none'
            }
        }
    }));
};
export default FailuresReportCatalog;
